import VueApollo from 'vue-apollo'

import coreBootstraps from '@wittignl/js-core/bootstrap'
import cmsBootstraps from '@wittignl/js-cms/bootstrap'
import appBootstraps from 'app/bootstrap'

import di from 'di'

import App from 'app/components/App.vue'
import RelayAccountType from 'app/auth/RelayAccountType'


// Bootstrap
const bootstrap = [

    ...coreBootstraps,
    ...cmsBootstraps,
    ...appBootstraps
];

bootstrap.forEach(strap => strap.run());

// Run
const router = di.get('router');
const i18n = di.get('i18n');
const acl = di.get('acl');
const auth = di.get('auth');
const logger = di.get('logger').child('Main');

const apolloProvider = new VueApollo({
    defaultClient: di.get('apollo'),
});


const run = () => {

    new App({
        'el': '#app-wrapper',
        provide: apolloProvider.provide(),
        router,
        i18n,
        acl,
        auth,
        breadcrumb: true,
        modal: true,
        toast: true
    });

    document.getElementsByClassName('full-screen-loader')[0].classList.remove('cloak');
};

// Check relay token
RelayAccountType.loginIfNeeded().then((session) => {

    if(session) {
        logger.info('Relay login successful');
    }
    else {
        logger.info('Relay login failed');
    }

    run();

}).catch(e => {

    logger.error('Error logging in via relay', e);
    run();
});
